
export function _checkBolt (tripSelectedDetails:any,tripReturnSelectedDetails:any){
  // es solo ida
  let isBoltIda=false;
  let isBoltVuelta=false;
  let result=false;
  if(tripSelectedDetails!=null){
    let filtro=tripSelectedDetails?.summaryAmount?.departure?.transports.find((o:any) => o.line == "Bolt");
    if(filtro){
      isBoltIda=true
    }
    
  }
  if(tripReturnSelectedDetails!=null){
    let filtro=tripReturnSelectedDetails?.summaryAmount?.arrival?.transports.find((o:any) => o.line == "Bolt");
    if(filtro){
      isBoltVuelta=true
    }
  }

  if(isBoltIda || isBoltVuelta){
    result=true
  }
  return result

}


export function monoModalCardMapping(data: any, t: any, type: any, isRoundTrip: boolean) {

  let resultDeparture = [] as any;
  let resultTrainDeparture = [] as any;

  // Si data es undefined o no es un array, devolvemos un array vacío
  if (!Array.isArray(data)) {
    return [];
  }

  // Filtro la data dependiendo de isRoundTrip
  const filteredData = data.filter((item: any) => {
    if (isRoundTrip) {
      // Solo objetos donde informative es false
      return item.informative === false;
    } else {
      // Si no es round trip, se permite cualquier valor de informative
      return true;
    }
  });

  // Mapeamos los objetos filtrados
  filteredData.map((item: any) => {
    if (item.informative === false && item.idTariff!=undefined && (item?.isIncluding === false || item?.isIncluding === undefined)) {

    const date = new Date(item.departureDate);
    let dateAux = date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });

    const aux = {
      text: item.icon === "ave" ? t('ave') : item.icon === "cercanias" ? t('cercanias') : item.transport,
      price: item.price,
      priceNumber: item.priceNumber,
      departure: item.route,
      arrival: item.destiny,
      date: dateAux,
      rangetime: item.departureTime + " - " + item.arrivalTime,
      num: item.passager,
      totalPriceWithoutExtras: item.totalPriceWithoutExtras,
      transport: item.transport,
      icon: item.icon,
      line: item.line,
      priceFinal: item.priceNumber,
      idTariff: item.idTariff,
      type: type,
      isPaidTrip: item.isPaidTrip ? item.isPaidTrip : false
    };

    // Agregamos a resultDeparture según sea necesario
    resultDeparture.push(aux);
  }
  });

  // Concatenamos los resultados de departure y train departure
  if (type === "departure") {
    const body = resultDeparture.concat(resultTrainDeparture);
    return body;
  } else {
    let resultArrival = resultDeparture;
    let resultTrainArrival = resultTrainDeparture;

    const body = resultArrival.concat(resultTrainArrival);
    return body;
  }
}





export function checkIsRoundTrip(departure: any, arrival: any): boolean {
// Verificamos si ambas variables son arreglos y están llenas
const isDepartureFilled = Array.isArray(departure) && departure.length > 0;
const isArrivalFilled = Array.isArray(arrival) && arrival.length > 0;

// Retornamos true solo si ambos están llenos
return isDepartureFilled && isArrivalFilled;
}